import {
  Box,
  Divider,
  Link,
  Stack,
  Typography,
} from "@mui/material";
import { useRef } from "react";
import { styled } from "@mui/material/styles";
import { getColorForIndex } from "../../../utilities";
import PrintingCakePreviewDialog from "../../cart/PrintingCakePreviewDialog";
function OrderProductItem({ index, data, divider }) {
  const dialogRef = useRef(null);
  // const discountPrice = data?.product_total;
  const discountPrice = data?.promo_code_percentage
  ? data?.best_product_total
  : data?.product_total;
  const handlePreviewDialog = () => dialogRef.current?.openDialog();

  return (
    <>
      <Box
        display="flex"
        flexDirection="column"
        key={data?.order_product_id || data?.order_addons_id} // ✅ Already correct
        sx={{
          px: { xs: 1, md: 1.5 },
          py: 1.25,
          border: "1px solid rgba(183, 124, 10, 0.16)",
          borderRadius: "14px",
          background: "rgba(255,255,255,0.82)",
        }}
      >
        {/* ✅ Row 1: Product Name (Mobile only) */}
        <Box sx={{ mb: 1, display: { xs: "block", md: "none" } }}>
          <CakeName>{data?.product_details?.[0]?.product_name}</CakeName>
        </Box>

        {/* ✅ Row 2: Image + details (Name included for md+) */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: 2,
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          {/* Product Image */}
          <CartImage
            src={data?.product_details?.[0]?.images?.[0]?.app_product_image}
            alt={data?.product_details?.[0]?.product_name}
          />

          {/* Details */}
          <Box sx={{ flexGrow: 1 }}>
            <Stack
              direction="row"
              spacing={1}
              useFlexGap
              sx={{
                alignItems: "center",
                flexWrap: "wrap",
              }}
            >
              {/* ✅ Name shown only on md+ (hidden on mobile) */}
              <CakeName sx={{ display: { xs: "none", md: "block" } }}>
                {data?.product_details?.[0]?.product_name}
              </CakeName>

              {/* Weight */}
              <Typography
                variant="h3"
                sx={{
                  fontWeight: 500,
                  fontSize: "14px",
                  color: "var(--neutral-500)",
                  lineHeight: "157%",
                }}
              >
                {data?.variation?.weight?.[0]
                  ? `${data.variation.weight[0].weight_name} ${data.variation.weight[0].unit.unit_name}`
                  : "-"}
              </Typography>
              <Typography
                variant="h3"
                sx={{
                  fontWeight: 600,
                  fontSize: "14px",
                  color: "var(--neutral-800)",
                }}
              >
                Qty {data?.product_quantity}
              </Typography>

              {/* Combo Tag */}
              {data?.parent_id > 0 && <ComboTag />}

              {/* Upload Link for Photo Cake */}
              {+data?.product_details?.[0]?.shape_id > 0 &&
                data?.product_details?.[0]?.photo_cakes_images?.[0]
                  ?.photo_cake_image && (
                  <Link
                    component="button"
                    variant="body2"
                    sx={{
                      fontWeight: 600,
                      fontSize: "12px",
                      display: "flex",
                      alignItems: "center",
                      gap: 0.5,
                    }}
                    onClick={handlePreviewDialog}
                  >
                    View print file
                  </Link>
                )}
            </Stack>
          </Box>

          {/* Price */}
          <Typography
            variant="h3"
            sx={{
              fontWeight: 600,
              fontSize: "16px",
              color: "var(--neutral-black)",
              textAlign: { xs: "center", md: "left" },
            }}
          >
            ₹ {discountPrice}
          </Typography>
        </Box>
      </Box>

      {divider && <Divider variant="middle" sx={{ my: 1.5 }} />}
      <PrintingCakePreviewDialog
        ref={dialogRef}
        uploadedImage={
          data?.product_details?.[0]?.photo_cakes_images?.[0]?.photo_cake_image
        }
      />
    </>
  );
}

const CartImage = styled("img")(({ theme, index }) => ({
  backgroundColor: getColorForIndex(index),
  textAlign: "center",
  width: "72px",
  height: "72px",
  borderRadius: "12px",
  cursor: "pointer",
  objectFit: "cover",
  [theme.breakpoints.down("sm")]: {
    width: "72px !important",
    height: "72px !important",
  },
}));
const ComboTag = () => {
  const StyledComboTag = styled("span")(({ theme }) => ({
    backgroundColor: "rgba(210, 74, 38, 0.12)",
    height: "auto",
    color: "#9B3119",
    fontWeight: "bold",
    fontSize: "0.65rem",
    padding: "0.2rem 0.5rem",
    borderRadius: "999px",
    border: "1px solid rgba(210, 74, 38, 0.18)",
    display: "inline-block",
    userSelect: "none",
  }));

  return <StyledComboTag>COMBO</StyledComboTag>;
};
const CakeName = styled("h3")(({ theme }) => ({
  margin: 0,
  fontWeight: 700,
  fontSize: "16px",
  lineHeight: "150%",
  color: "#2C2418",
  textAlign: "left",
  textTransform: "capitalize",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  [theme.breakpoints.down("sm")]: {
    fontSize: "14px !important",
  },
}));
export default OrderProductItem;
